import * as yup from 'yup';

export const externalIdpLogoutConfigSchema = yup
  .object()
  .shape({
    enabled: yup.boolean().default(false).required(),
    redirectUrl: yup
      .string()
      .min(6, 'Redirect url must contain at least 6 characters')
      .url('Invalid url')
      .test(
        'check-url',
        'Invalid protocol',
        (value) => value?.toLowerCase()?.startsWith('https') ?? false,
      )
      .max(512, 'Redirect url should not exceed 512 characters')
      .required('Redirect url is required'),
  })
  .transform((val) => val ?? undefined)
  .default(undefined)
  .notRequired();
